import moment from 'moment';

export function formatPromotionDate(value) {
  if (!value) return '';
  // SQL dates are Cambodia wall time; ISO dates carry their own UTC offset.
  const date = /(?:Z|[+-]\d{2}:\d{2})$/.test(String(value))
    ? moment.parseZone(value).utcOffset(420) : moment(value);
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : '';
}

export function promotionFields(promotion) {
  return {
    promotionHistoryId: promotion ? promotion.id : null,
    promotionPrice: promotion ? promotion.price : null,
    promotionPriceDate: promotion && promotion.date_from && promotion.date_to
      ? `${formatPromotionDate(promotion.date_from)} - ${formatPromotionDate(promotion.date_to)}` : null,
    promotionDirty: false,
  };
}
